// extracted by mini-css-extract-plugin
module.exports = {"calendarRangeNavigation":"ob_ej12Vv","yearNavigation":"ob_KsjLMG","yearNavigation__title":"ob_5syAoc","yearNavigation__previous":"ob_KqwH7J","yearNavigation__next":"ob_gtU5YM"};